
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '~/tailwind.config.js'

export default {
  props: {
    asideNavItems: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  watch: {
    asideNavItems: {
      deep: true,
      handler(navItems) {
        this.handleAnchorState(navItems)
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnim()
      this.handleAnchorState(this.asideNavItems)
    })
  },
  methods: {
    initAnim() {
      if (this.asideNavItems.length === 0) return
      // initial animation
      this.$gsap.from('.nav-items', {
        duration: 0.5,
        delay: 1,
        alpha: 0,
        x: '+=30',
        ease: 'Power3.easeInOut',
        stagger: 0.15,
      })
    },
    handleAnchorState(navItems = []) {
      const fullConfig = resolveConfig(tailwindConfig)
      navItems.forEach((section) => {
        this.$ScrollTrigger.create({
          trigger: section.scroll_to_target_id,
          // markers: true,
          start: 'top center',
          end: 'bottom center',
          onEnter: () => {
            this.$gsap.set(
              [`#${section.id}-nav`, `#${section.id}-nav-mobile`],
              {
                color: fullConfig.theme.colors['blue-500'],
              }
            )
          },
          onEnterBack: () => {
            this.$gsap.set(
              [`#${section.id}-nav`, `#${section.id}-nav-mobile`],
              {
                color: fullConfig.theme.colors['blue-500'],
              }
            )
          },
          onLeave: () => {
            this.$gsap.set(
              [`#${section.id}-nav`, `#${section.id}-nav-mobile`],
              {
                color: fullConfig.theme.colors.iwbi['cool-gray-2'],
              }
            )
          },
          onLeaveBack: () => {
            this.$gsap.set(
              [`#${section.id}-nav`, `#${section.id}-nav-mobile`],
              {
                color: fullConfig.theme.colors.iwbi['cool-gray-2'],
              }
            )
          },
        })
      })
    },
    handleScroll($event) {
      // scroll to section
      const scrollTarget = $event.target.dataset.target

      this.$gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: scrollTarget,
          offsetY: 70,
        },
      })
    },
  },
}
